import React, { useState, useEffect } from "react";
import "./Home.scss";
import { isTokenExpired, removeToken } from "../../utils/Helper";
import usePersistentPayerCode from "../../hooks/usePersistentPayerCode";
import BannerTemplate from "./BannerTemplate";
import AboutTemplate from "./AboutTemplate";
import TargetTemplate from "./TargetTemplate";
import PayerTemplate from "./PayerTemplate";
import FooterTemplate from "./FooterTemplate";
import HeaderTemplate from "./HeaderTemplate";

const Home: React.FC = () => {
  const [showNavbar, setShowNavbar] = React.useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isAtTop, setIsAtTop] = useState(true);
  const [scroll, setScroll] = useState(false);
  usePersistentPayerCode();
  useEffect(() => {
    const handleScroll = () => {
      setIsAtTop(window.scrollY === 0);
      setScroll(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);

    // Initial check
    handleScroll();

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    const checkAuth = () => {
      if (isTokenExpired()) {
        removeToken();
      }
    };

    checkAuth();
  }, []);

  useEffect(() => {
    if (localStorage.getItem("userToken")) {
      setIsLoggedIn(true);
    }
  }, [isLoggedIn]);

  return (
    <>
      <main className={showNavbar ? "overflow-hidden" : ""}>
        <HeaderTemplate />
        <BannerTemplate />
        <AboutTemplate />
        <TargetTemplate />
        <PayerTemplate />
        <FooterTemplate />
      </main>
    </>
  );
};

export default Home;
